var indentStyle = {"indentZero":"StDzC","indentOne":"jH5Tn","indentTwo":"jBgbu","indentThree":"uG-Rk","indentFour":"wr6uB","indentFive":"DwaD4","indentSix":"G6a-L"};

export { indentStyle as i };
//# sourceMappingURL=indentation-cf7332bc.js.map
